export default function () {
  return {
    contracts: undefined,
    contractReimbursements: undefined,
    originalContracts: undefined,
    beforeChangeContracts: undefined,
    responseData: undefined,
    medicalSelectionResponse: undefined,
    isLoadingValidateContract: false,
    isLoadingContracts: false,
    isLoadingContractReimbursements: false,
    isSavingContracts: false,
    isSavingContractsSuccesfull: false,
    unselectedRequiredPackages: [],
    showUnselectedRequiredPackages: false,
    requestedContractsAreForNewlyInsuredPersons: false,
  };
}
